export const SCROll = "SCROLL";
export const scrolling = (data) => {
    return {
        type: SCROll,
        payload:data
    }
}
